import { Marketplace } from '@spike/marketplace-model';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const useSettingsMarketplace = (): Marketplace => {
    const marketplace = useSelector<RootState, Marketplace>(state => state.marketplace.settingsMarketplace);
    return marketplace;
};

export default useSettingsMarketplace;
